import { useForm } from "@tanstack/react-form"

import { X } from "lucide-react"

import { Field, FieldError } from "@/components/ui/Field"
import { Input } from "@/components/ui/Input"

interface ClassTimeStepProps {
  value: string
  onChange: (value: string) => void
  onValidation?: (isValid: boolean) => void
}

export function ClassTimeStep({
  value,
  onChange,
  onValidation,
}: ClassTimeStepProps) {
  const form = useForm({
    defaultValues: {
      classTime: value,
    },
  })

  return (
    <div className="tw-text-center tw-space-y-6">
      <h2 className="tw-text-3xl tw-font-bold tw-text-gray-800">
        How much time will students have for this assignment?
      </h2>

      <form.Field
        name="classTime"
        validators={{
          onChange: ({ value }: { value: string }) =>
            !value.trim() ? "Please enter the time duration" : undefined,
        }}
      >
        {(field) => {
          return (
            <Field>
              <Input
                id={field.name}
                type="text"
                value={field.state.value}
                onBlur={() => {
                  field.handleBlur()
                  onChange(field.state.value)
                }}
                onChange={(e) => {
                  field.handleChange(e.target.value)
                  onChange(e.target.value)
                }}
                placeholder="e.g., 30 minutes, 1 hour, 45 mins"
                aria-invalid={field.state.meta.errors.length > 0}
                className="tw-w-full tw-max-w-xl tw-mx-auto tw-px-6 tw-py-4 tw-border-2 tw-border-dashed tw-rounded-sm tw-text-center tw-text-lg tw-text-gray-700 tw-transition-all focus:tw-outline-none focus:tw-ring-2 tw-border-green-300 focus:tw-border-green-500 focus:tw-ring-green-500"
              />
              <FieldError>
                {field.state.meta.errors.length > 0 && (
                  <span className="tw-flex tw-justify-center tw-text-sm tw-items-center tw-gap-1 tw-pt-2">
                    <X className="tw-w-4 tw-h-4" />
                    {field.state.meta.errors[0]}
                  </span>
                )}
              </FieldError>
            </Field>
          )
        }}
      </form.Field>
    </div>
  )
}
